export const PaymentGatewayEndpoint = {
  getAllSettlementPayment: "/getAllTransactionPayment",
  paymentGatewaySettlement: "marketPlaceSettlement",
  exportExcelTransaction: "marketPlaceSettlement/export/excel/transaction",
  exportExcelSettlement: "marketPlaceSettlement/export/excel/settlement",
  importExcel: "marketPlaceSettlement/importExcel",

  marketPlaceSettlementTransactions: "marketPlaceSettlement/transactions",
  marketPlaceSettlementFranchiseeDetails:
    "marketPlaceSettlement/franchisee/details",
};
